export default "__VITE_ASSET__3aaede1d__"